<div class="npdc-title">
  <h1>{{ placename().title }}</h1>
  <div class="npdc-title__actions">
    @if (authService.canInvoke(authService.endpoints.editPlacename)) {
      <a mat-flat-button routerLink="edit">Edit</a>
    }
    @if (authService.canInvoke(authService.endpoints.deletePlacename)) {
      <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More actions">
        <mat-icon>more_vert</mat-icon>
      </button>
    }
  </div>
</div>

@if (placename().keywords.length) {
  <p class="link-chip-set">
    @for (k of placename().keywords; track $index) {
      <a class="mat-mdc-chip" routerLink=".." [queryParams]="{ q: k }">
        <mat-chip>{{ k }}</mat-chip>
      </a>
    }
  </p>
}

<mat-card class="npdc-leaflet" appearance="outlined">
  <app-leaflet-group [geometry]="geometry()"></app-leaflet-group>
</mat-card>

@if (placename().description) {
  <h2>Description</h2>
  <p
    style="white-space: pre-line"
    [innerHtml]="placename().description | link: '/placename?q='"
  ></p>
}

@if (placename().origin) {
  <h2>Origin</h2>
  <p style="white-space: pre-line">
    {{ placename().origin }}
  </p>
}

@if (placename().comment) {
  <h2>Comment</h2>
  <p style="white-space: pre-line">
    {{ placename().comment }}
  </p>
}

<h2>Facts</h2>
<mat-list>
  <mat-list-item>
    <mat-icon matListItemIcon>location_on</mat-icon>
    <span matListItemTitle>Status</span>
    <span matListItemLine>{{ placename().status }}</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>location_on</mat-icon>
    <span matListItemTitle>Country</span>
    <span matListItemLine>{{ placename().country }}</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>location_on</mat-icon>
    <span matListItemTitle>Area</span>
    <span matListItemLine>{{ placename().area || 'N/A' }}</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>location_on</mat-icon>
    <span matListItemTitle>Coordinates</span>
    <span matListItemLine>{{ placename().geometry.coordinates | json }}</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item>
    <mat-icon matListItemIcon>landscape</mat-icon>
    <span matListItemTitle>Terrain</span>
    <span matListItemLine>{{ placename().terrain || 'N/A' }}</span>
  </mat-list-item>

  <mat-list-item>
    <mat-icon matListItemIcon>landscape</mat-icon>
    <span matListItemTitle>Type</span>
    <span matListItemLine>{{ placename().type || 'N/A' }}</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item>
    <mat-icon matListItemIcon>flag</mat-icon>
    <span matListItemTitle>Country of authority</span>
    <span matListItemLine>{{ placename().authority || 'N/A' }}</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item>
    <mat-icon matListItemIcon>timeline</mat-icon>
    <span matListItemTitle>Start</span>
    <span matListItemLine>{{ placename().start || 'N/A' }}</span>
  </mat-list-item>

  <mat-list-item>
    <mat-icon matListItemIcon>timeline</mat-icon>
    <span matListItemTitle>End</span>
    <span matListItemLine>{{ placename().end || 'N/A' }}</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item>
    <mat-icon matListItemIcon>group</mat-icon>
    <span matListItemTitle>Proposer</span>
    <span matListItemLine>{{ placename().proposer || 'N/A' }}</span>
  </mat-list-item>
</mat-list>

@if (selectedIndex() !== -1) {
  <h2>Relations</h2>

  <mat-tab-group animationDuration="0ms" disablePagination="true" [selectedIndex]="selectedIndex()">
    <mat-tab [disabled]="!cases.value()?.count">
      <ng-template mat-tab-label
        ><mat-icon>folder_open</mat-icon>Cases ({{ cases.value()?.count }})</ng-template
      >
      <p>Naming committee cases referencing or assigning this name.</p>
      <app-list [resource]="cases" [disableClear]="true">
        @if (!cases.error()) {
          <mat-nav-list>
            @for (c of cases.value()?.items; track c.id) {
              <a mat-list-item routerLink="/placename/case/{{ c.id }}">
                <mat-icon matListItemIcon>folder_open</mat-icon>
                <span matListItemTitle>{{ c.title }}</span>
                <span matListItemLine>{{ c.area || 'N/A' }}, {{ c.date | date: 'yyyy' }}</span>
                <span matListItemLine>Case {{ c.number || 'N/A' }}</span>
              </a>
            }
          </mat-nav-list>

          <mat-paginator
            showFirstLastButtons
            (page)="casesPage.set($event.pageIndex)"
            [length]="cases.value()?.count"
            [pageIndex]="casesPage()"
            [pageSize]="10"
            [hidePageSize]="true"
          >
          </mat-paginator>
        }
      </app-list>
    </mat-tab>
    <mat-tab [disabled]="!alternative.value()?.count">
      <ng-template mat-tab-label
        ><mat-icon>location_on</mat-icon>Alternatives ({{
          alternative.value()?.count
        }})</ng-template
      >
      <p>Alternative names for this area. E.g. names assigned by different naming authorities.</p>
      <ng-container
        [ngTemplateOutlet]="placenameListTemplate"
        [ngTemplateOutletContext]="{
          data: alternative,
          page: alternativePage,
        }"
      >
      </ng-container>
    </mat-tab>
    <mat-tab [disabled]="!replacedBy.value()?.count">
      <ng-template mat-tab-label
        ><mat-icon>location_on</mat-icon>Replaced by ({{ replacedBy.value()?.count }})</ng-template
      >
      <ng-container
        [ngTemplateOutlet]="placenameListTemplate"
        [ngTemplateOutletContext]="{ data: replacedBy, page: replacedByPage }"
      >
      </ng-container>
    </mat-tab>
    <mat-tab [disabled]="!replaces.value()?.count">
      <ng-template mat-tab-label
        ><mat-icon>location_on</mat-icon>Replaces ({{ replaces.value()?.count }})</ng-template
      >
      <ng-container
        [ngTemplateOutlet]="placenameListTemplate"
        [ngTemplateOutletContext]="{ data: replaces, page: replacesPage }"
      >
      </ng-container>
    </mat-tab>
  </mat-tab-group>
}

<h2>Other</h2>
<mat-list>
  <mat-list-item>
    <div matListItemTitle>Created</div>
    <span matListItemLine
      >{{ placename().created | date }} by
      @if (placename().createdBy | resolveUser | async; as user) {
        <a href="mailto:{{ user.email }}">{{ user.email }}</a>
      } @else {
        {{ placename().createdBy }}
      }
    </span>
  </mat-list-item>
  <mat-list-item>
    <div matListItemTitle>Modified</div>
    <span matListItemLine
      >{{ placename().modified | date }} by
      @if (placename().modifiedBy | resolveUser | async; as user) {
        <a href="mailto:{{ user.email }}">{{ user.email }}</a>
      } @else {
        {{ placename().modifiedBy }}
      }
    </span>
  </mat-list-item>
</mat-list>

<mat-menu #optionsMenu>
  <button mat-menu-item (click)="delete()">Delete</button>
</mat-menu>

<ng-template #placenameListTemplate let-data="data" let-page="page">
  <p>
    <app-list [resource]="data" [disableClear]="true">
      @if (!data.error()) {
        <mat-nav-list>
          @for (p of data.value()?.items; track p.id) {
            <a mat-list-item routerLink="/placename/{{ p.id }}">
              <mat-icon matListItemIcon>location_on</mat-icon>
              <span matListItemTitle>{{ p.title }}</span>
              <span matListItemLine>{{ p.area || 'N/A' }}, {{ p.start }}</span>
              <span matListItemLine>{{ p.keywords.join(', ') || 'N/A' }}</span>
            </a>
          }
        </mat-nav-list>

        <mat-paginator
          showFirstLastButtons
          (page)="page.set($event.pageIndex)"
          [length]="data.value()?.count"
          [pageIndex]="page()"
          [pageSize]="10"
          [hidePageSize]="true"
        >
        </mat-paginator>
      }
    </app-list>
  </p>
</ng-template>
